import React, { useState, useCallback, useContext, useMemo } from 'react';
import KPITrendStyled from './KPITrendStyled';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import { Box, MenuItem, useTheme } from '@material-ui/core';
import { BarChart } from 'echarts/charts';
import SvgIcon from '@/components/SvgIconML/SvgIconML';
import { TitleComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { useSelector } from 'dva';
import Loading from '@/components/LoadingML/LoadingML';
import NoData from '@/components/no_data_show/NoData';
// import TooltipsML from '@/components/TooltipsML/TooltipsML';
import { fmtPercent } from '@/utils/comUtil';
import { fmtThousand } from '@/utils/comUtil';
import numsDown from '@/assets/img/numsDown.png';
import numsUp from '@/assets/img/numsUp.png';
import { useIntl } from 'umi';
echarts.use([TitleComponent, CanvasRenderer, BarChart]);

// 图表容器样式提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };

const KPITrend = () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const theme = useTheme();
  const [iconId, setIconId] = useState(0);

  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { charts } = themeContext[brandContext];

  const KpiBasketData = useSelector((state) => state.bhc.KpiBasketData);
  const KpiContributionData = useSelector(
    (state) => state.bhc.KpiContributionData,
  );
  const KpiCustomerData = useSelector((state) => state.bhc.KpiCustomerData);
  const KpiRecruitmentData = useSelector(
    (state) => state.bhc.KpiRecruitmentData,
  );
  const KpiRepeatData = useSelector((state) => state.bhc.KpiRepeatData);
  const KpiRetentionData = useSelector((state) => state.bhc.KpiRetentionData);
  const KpiSpendingData = useSelector((state) => state.bhc.KpiSpendingData);
  const KpiUptData = useSelector((state) => state.bhc.KpiUptData);

  const yearFirst = useSelector((state) => state.bhc.yearFirst) || '';
  const yearSecond = useSelector((state) => state.bhc.yearSecond) || '';

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['bhc/getKpiList'];

  const showCondition = [
    {
      id: 0,
      name: '',
      icon: 'KpiCustomer',
      // value: '会员数',
      value: formatMessage({ id: 'report.health.n05.lbl02' }),
      // title: '在统计范围最大时间之前的所有会员数，统计范围内注册的为新用户，统计范围之前的为老用户',
      title: formatMessage({ id: 'report.health.n05.tip03' }),
    },
    {
      id: 1,
      name: '',
      icon: 'Recruitment',
      // value: '新招募会员数',
      value: formatMessage({ id: 'report.health.n05.lbl04' }),
      // title: '统计范围内注册的会员数，只有新会员',
      title: formatMessage({ id: 'report.health.n05.tip05' }),
    },
    {
      id: 2,
      name: '',
      icon: 'AverageSpending',
      // value: '人均购买金额',
      value: formatMessage({ id: 'report.health.n05.lbl06' }),
      title: (
        <>
          {/* <span>新会员：新会员购买金额总和 / 有购买会员总数</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip07' })}</span>
          <br />
          {/* <span>老会员：老会员购买金额总和 / 有购买会员总数</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip08' })}</span>
        </>
      ),
    },
    {
      id: 3,
      name: '',
      icon: 'RepeatPurchase',
      // value: '复购率（%）',
      value: `${formatMessage({ id: 'report.health.n05.lbl09' })}（%）`,
      title: (
        <>
          {/* <span>按照月份计算，统计范围R12月</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip10' })}</span>
          <br />
          <span>
            {/* 新会员：R12月内新会员购买次数>1 / R12月内注册新会员购买次数>0 */}
            {formatMessage({ id: 'report.health.n05.tip11' })}
          </span>
          <br />
          {/* <span>老会员：R12月内老会员购买次数>1 / R12月内老会员购买次数>0</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip12' })}</span>
        </>
      ),
    },
    {
      id: 4,
      name: '',
      icon: 'BasketSize',
      // value: '客单价',
      value: formatMessage({ id: 'report.health.n05.lbl13' }),
      title: (
        <>
          {/* <span>新会员：新会员购买金额 / 新会员购买订单数</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip14' })}</span>
          <br />
          {/* <span>老会员：老会员购买金额 / 老会员购买订单数</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip15' })}</span>
        </>
      ),
    },
    {
      id: 5,
      name: '',
      icon: 'Retention',
      // value: '留存率（%）',
      value: `${formatMessage({ id: 'report.health.n05.lbl16' })}（%）`,
      title: (
        <>
          {/* <span>按照月份计算，统计范围R12月，（只有老会员有数值）</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip17' })}</span>
          <br />
          {/* <span>老会员：会员在本期R12和上期R12均是购买会员的会员数 / 上期R12有购买的会员数</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip18' })}</span>
        </>
      ),
    },
    // {
    //   id: 6,
    //   name: '',
    //   icon: 'MemberContribution',
    //   // value: '会员贡献率（%）',
    //   value: `${formatMessage({ id: 'report.health.n05.lbl19' })}（%）`,
    //   title: (
    //     <>
    //       {/* <span>新会员：新会员购买金额总和 / 当月总的购买金额(包含非会员)</span> */}
    //       <span>{formatMessage({ id: 'report.health.n05.tip20' })}</span>
    //       <br />
    //       {/* <span>老会员：老会员购买金额总和 / 当月总的购买金额(包含非会员)</span> */}
    //       <span>{formatMessage({ id: 'report.health.n05.tip21' })}</span>
    //     </>
    //   ),
    // },
    {
      id: 7,
      name: '',
      icon: 'UPT',
      // value: '客单件',
      value: formatMessage({ id: 'report.health.n05.lbl22' }),
      title: (
        <>
          {/* <span>新会员：新会员购买双数 / 新会员购买订单数 </span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip23' })}</span>
          <br />
          {/* <span>老会员：老会员购买双数 / 老会员购买订单数</span> */}
          <span>{formatMessage({ id: 'report.health.n05.tip24' })}</span>
        </>
      ),
    },
  ];

  const LYNewData = useMemo(() => {
    const showLen = new Map([
      [0, KpiCustomerData[0]?.LYNewSortName],
      [1, KpiRecruitmentData[0]?.LYNewSortName],
      [2, KpiSpendingData[0]?.LYNewSortName],
      [3, KpiRepeatData[0]?.LYNewSortName],
      [4, KpiBasketData[0]?.LYNewSortName],
      [5, KpiRetentionData[0]?.LYNewSortName],
      [6, KpiContributionData[0]?.LYNewSortName],
      [7, KpiUptData[0]?.LYNewSortName],
    ]);
    const dataLen = showLen.get(iconId);

    const currentData =
      [
        KpiCustomerData,
        KpiRecruitmentData,
        KpiSpendingData,
        KpiRepeatData,
        KpiBasketData,
        KpiRetentionData,
        KpiContributionData,
        KpiUptData,
      ][iconId] || [];

    if (currentData.length > 0) {
      const showData = new Map([
        [0, KpiCustomerData[0]?.LYNewData],
        [1, KpiRecruitmentData[0]?.LYNewData],
        [2, KpiSpendingData[0]?.LYNewData],
        [3, KpiRepeatData[0]?.LYNewData],
        [4, KpiBasketData[0]?.LYNewData],
        [5, KpiRetentionData[0]?.LYNewData],
        [6, KpiContributionData[0]?.LYNewData],
        [7, KpiUptData[0]?.LYNewData],
      ]);
      if (Number(dataLen) > 1) {
        const forcastData = Array(dataLen - 1).fill('N/A');
        return forcastData.concat(showData.get(iconId));
      }
      return showData.get(iconId);
    }
    return [];
  }, [
    KpiCustomerData,
    KpiRecruitmentData,
    KpiSpendingData,
    KpiRepeatData,
    KpiBasketData,
    KpiRetentionData,
    KpiContributionData,
    KpiUptData,
    iconId,
  ]);

  const LYExitData = useMemo(() => {
    const showLen = new Map([
      [0, KpiCustomerData[1]?.LYExitSortName],
      [1, KpiRecruitmentData[1]?.LYExitSortName],
      [2, KpiSpendingData[1]?.LYExitSortName],
      [3, KpiRepeatData[1]?.LYExitSortName],
      [4, KpiBasketData[1]?.LYExitSortName],
      [5, KpiRetentionData[1]?.LYExitSortName],
      [6, KpiContributionData[1]?.LYExitSortName],
      [7, KpiUptData[1]?.LYExitSortName],
    ]);
    const dataLen = showLen.get(iconId);
    if (
      KpiBasketData?.length > 0 &&
      KpiContributionData?.length > 0 &&
      KpiCustomerData?.length > 0 &&
      KpiRecruitmentData?.length > 0 &&
      KpiRepeatData?.length > 0 &&
      KpiRetentionData?.length > 0 &&
      KpiSpendingData?.length > 0 &&
      KpiUptData?.length > 0
    ) {
      const showData = new Map([
        [0, KpiCustomerData[1]?.LYExitData],
        [1, KpiRecruitmentData[1]?.LYExitData],
        [2, KpiSpendingData[1]?.LYExitData],
        [3, KpiRepeatData[1]?.LYExitData],
        [4, KpiBasketData[1]?.LYExitData],
        [5, KpiRetentionData[1]?.LYExitData],
        [6, KpiContributionData[1]?.LYExitData],
        [7, KpiUptData[1]?.LYExitData],
      ]);
      if (Number(dataLen) > 1) {
        const forcastData = Array(dataLen - 1).fill('N/A');
        return forcastData.concat(showData.get(iconId));
      }
      return showData.get(iconId);
    }
    return [];
  }, [
    KpiCustomerData,
    KpiRecruitmentData,
    KpiSpendingData,
    KpiRepeatData,
    KpiBasketData,
    KpiRetentionData,
    KpiContributionData,
    KpiUptData,
    iconId,
  ]);

  const TYNewData = useMemo(() => {
    const showLen = new Map([
      [0, KpiCustomerData[2]?.TYNewSortName],
      [1, KpiRecruitmentData[2]?.TYNewSortName],
      [2, KpiSpendingData[2]?.TYNewSortName],
      [3, KpiRepeatData[2]?.TYNewSortName],
      [4, KpiBasketData[2]?.TYNewSortName],
      [5, KpiRetentionData[2]?.TYNewSortName],
      [6, KpiContributionData[2]?.TYNewSortName],
      [7, KpiUptData[2]?.TYNewSortName],
    ]);
    const dataLen = showLen.get(iconId);
    if (
      KpiBasketData?.length > 0 &&
      KpiContributionData?.length > 0 &&
      KpiCustomerData?.length > 0 &&
      KpiRecruitmentData?.length > 0 &&
      KpiRepeatData?.length > 0 &&
      KpiRetentionData?.length > 0 &&
      KpiSpendingData?.length > 0 &&
      KpiUptData?.length > 0
    ) {
      const showData = new Map([
        [0, KpiCustomerData[2]?.TYNewData],
        [1, KpiRecruitmentData[2]?.TYNewData],
        [2, KpiSpendingData[2]?.TYNewData],
        [3, KpiRepeatData[2]?.TYNewData],
        [4, KpiBasketData[2]?.TYNewData],
        [5, KpiRetentionData[2]?.TYNewData],
        [6, KpiContributionData[2]?.TYNewData],
        [7, KpiUptData[2]?.TYNewData],
      ]);
      if (Number(dataLen) > 1) {
        const forcastData = Array(dataLen - 1).fill('N/A');
        return forcastData.concat(showData.get(iconId));
      }
      return showData.get(iconId);
    }
    return [];
  }, [
    KpiCustomerData,
    KpiRecruitmentData,
    KpiSpendingData,
    KpiRepeatData,
    KpiBasketData,
    KpiRetentionData,
    KpiContributionData,
    KpiUptData,
    iconId,
  ]);

  const TYExitData = useMemo(() => {
    const showLen = new Map([
      [0, KpiCustomerData[3]?.TYExitSortName],
      [1, KpiRecruitmentData[3]?.TYExitSortName],
      [2, KpiSpendingData[3]?.TYExitSortName],
      [3, KpiRepeatData[3]?.TYExitSortName],
      [4, KpiBasketData[3]?.TYExitSortName],
      [5, KpiRetentionData[3]?.TYExitSortName],
      [6, KpiContributionData[3]?.TYExitSortName],
      [7, KpiUptData[3]?.TYExitSortName],
    ]);
    const dataLen = showLen.get(iconId);
    if (
      KpiBasketData?.length > 0 &&
      KpiContributionData?.length > 0 &&
      KpiCustomerData?.length > 0 &&
      KpiRecruitmentData?.length > 0 &&
      KpiRepeatData?.length > 0 &&
      KpiRetentionData?.length > 0 &&
      KpiSpendingData?.length > 0 &&
      KpiUptData?.length > 0
    ) {
      const showData = new Map([
        [0, KpiCustomerData[3]?.TYExitData],
        [1, KpiRecruitmentData[3]?.TYExitData],
        [2, KpiSpendingData[3]?.TYExitData],
        [3, KpiRepeatData[3]?.TYExitData],
        [4, KpiBasketData[3]?.TYExitData],
        [5, KpiRetentionData[3]?.TYExitData],
        [6, KpiContributionData[3]?.TYExitData],
        [7, KpiUptData[3]?.TYExitData],
      ]);
      if (Number(dataLen) > 1) {
        const forcastData = Array(dataLen - 1).fill('N/A');
        return forcastData.concat(showData.get(iconId));
      }
      return showData.get(iconId);
    }
    return [];
  }, [
    KpiCustomerData,
    KpiRecruitmentData,
    KpiSpendingData,
    KpiRepeatData,
    KpiBasketData,
    KpiRetentionData,
    KpiContributionData,
    KpiUptData,
    iconId,
  ]);

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    let xDataUse = [
      {
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.1' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n2月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.2' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n3月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.3' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      // 'Feb',
      {
        // value: 'TY LY \n4月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.4' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n5月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.5' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n6月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.6' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n7月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.7' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n8月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.8' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n9月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.9' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n10月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.10' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n11月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.11' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
      {
        // value: 'TY LY \n12月',
        value: `TY LY \n${formatMessage({ id: 'comm.month.lbl.12' })}`,
        textStyle: {
          color: 'rgb(125,125,125)',
        },
      },
    ];
    // let seriesData = [];
    // sinTimeDimensionSinIndexMulValue(data || []).forEach((e) => {
    //   xDataUse.push(e.LABEL);
    //   seriesData.push(e.VALUE);
    // });
    let option = {
      title: {
        text: `TY：${yearSecond}  LY： ${yearFirst}`,
        left: '20',
        top: '0',
        textStyle: {
          fontWeight: '400',
          fontSize: 16,
          fontFamily: 'CenturyGothic-Regular, Century Gothic',
          color: '#212121',
        },
      },
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      // barWidth: 30,
      barCategoryGap: '50%',
      legend: {
        right: 0,
        data: [
          formatMessage({ id: 'report.health.n05.lbl27' }),
          formatMessage({ id: 'report.health.n05.lbl28' }),
          formatMessage({ id: 'report.health.n05.lbl29' }),
          formatMessage({ id: 'report.health.n05.lbl30' }),
        ],
        itemWidth: 10,
        itemHeight: 10,
        top: 0,
        icon: 'rect',
      },
      grid: {
        top: 30,
        left: 10,
        right: 10,
        bottom: 0,
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          fontSize: 12,
        },
        confine: true,
        formatter: (data) => {
          // const toHTML = () => {
          const newArr = [];
          const percentArr = [];
          const label = data[0]?.axisValueLabel;
          // (ty-ly)/ly ty新-ly新/ly新
          // ty老/ly老/ly老
          const tyData = formatMessage({ id: 'report.health.n05.lbl27' });
          const lyData = formatMessage({ id: 'report.health.n05.lbl29' });
          const tyDataNew = formatMessage({ id: 'report.health.n05.lbl28' });
          const lyDataNew = formatMessage({ id: 'report.health.n05.lbl30' });
          const tyYearOnYear =
            (data.filter((i) => i.seriesName === tyData)[0]?.value -
              data.filter((i) => i.seriesName === lyData)[0]?.value) /
            data.filter((i) => i.seriesName === lyData)[0]?.value;
          const lyYearOnYear =
            (data.filter((i) => i.seriesName === tyDataNew)[0]?.value -
              data.filter((i) => i.seriesName === lyDataNew)[0]?.value) /
            data.filter((i) => i.seriesName === lyDataNew)[0]?.value;
          const yby = formatMessage({ id: 'report.health.n03.lbl04' });
          const num = data.map((item) => {
            if (item.seriesName === tyData) {
              return `${item.marker}${item.seriesName} : ${fmtThousand(
                item.data,
              )} （${yby}：${fmtPercent(tyYearOnYear, 2)} <img src=${
                tyYearOnYear >= 0 ? numsUp : numsDown
              } alt="" /> )`;
            }
            if (item.seriesName === tyDataNew) {
              return `${item.marker}${item.seriesName} : ${fmtThousand(
                item.data,
              )} （${yby}：${fmtPercent(lyYearOnYear, 2)} <img src=${
                lyYearOnYear >= 0 ? numsUp : numsDown
              } alt="" /> )`;
            }
            return `${item.marker}${item.seriesName} : ${fmtThousand(
              item.data,
            )}`;
          });
          const percentNum = data.map((item) => {
            if (item.seriesName === tyData) {
              return `${item.marker}${item.seriesName} : ${
                item.data
              }% （${yby}：${fmtPercent(tyYearOnYear, 2)} <img src=${
                tyYearOnYear >= 0 ? numsUp : numsDown
              } alt="" /> ) `;
            }
            if (
              item.seriesName ===
              formatMessage({ id: 'report.health.n05.lbl28' })
            ) {
              return `${item.marker}${item.seriesName} : ${
                item.data
              }% （${yby}：${fmtPercent(lyYearOnYear, 2)}  <img src=${
                lyYearOnYear >= 0 ? numsUp : numsDown
              } alt="" /> )`;
            }
            return `${item.marker}${item.seriesName} : ${item.data}%`;
          });
          newArr[0] = num[1]?.length > 0 ? num[1] : [];
          newArr[1] = num[0]?.length > 0 ? num[0] : [];
          newArr[2] = num[3]?.length > 0 ? num[3] : [];
          newArr[3] = num[2]?.length > 0 ? num[2] : [];
          percentArr[0] = percentNum[1]?.length > 0 ? percentNum[1] : [];
          percentArr[1] = percentNum[0]?.length > 0 ? percentNum[0] : [];
          percentArr[2] = percentNum[3]?.length > 0 ? percentNum[3] : [];
          percentArr[3] = percentNum[2]?.length > 0 ? percentNum[2] : [];

          if (iconId === 3 || iconId === 5 || iconId === 6) {
            let str = '';
            percentArr.forEach((item) => {
              str += item + '<br />';
            });
            return `${label}<br />${str} `;
          }
          if (iconId === 1) {
            newArr[0] = num[0]?.length > 0 ? num[0] : [];
            newArr[1] = num[1]?.length > 0 ? num[1] : [];
            newArr[2] = num[2]?.length > 0 ? num[2] : [];
            newArr[3] = num[3]?.length > 0 ? num[3] : [];
          }
          let str = '';
          newArr.forEach((item) => {
            str += item + '<br />';
          });
          return `${label}<br />${str}`;
          // };
          // return callback(ticket, toHTML());
        },
      },
      xAxis: {
        type: 'category',
        data: xDataUse, // ['天猫', '京东', '小程序', '线下门店'],
        axisLine: {
          lineStyle: {
            color: charts.axisLineColor,
            fontSize: 12,
          },
        },
      },
      yAxis: {
        type: 'value',
        axisTick: false,
        axisLine: false,
        axisLabel: {
          show: false,
          color: charts.yColor, //坐标值得具体的颜色
          fontSize: 12,
        },
        splitLine: {
          show: false, //去除网格线
          lineStyle: {
            color: charts.axisLineColor, //坐标线的颜色
          },
        },
        nameGap: 15,
        nameTextStyle: {
          padding: [0, 35, 0, 0],
        },
        min: 0,
      },
      series: [
        {
          name: formatMessage({ id: 'report.health.n05.lbl28' }),
          type: 'bar',
          stack: 'Search Engine',
          data: TYExitData,
          color: '#A385E2',
        },
        {
          name: formatMessage({ id: 'report.health.n05.lbl27' }),
          type: 'bar',
          stack: 'Search Engine',
          data: TYNewData,
          color: '#F2A3F2',
        },
        {
          // name: 'LY 老会员',
          name: formatMessage({ id: 'report.health.n05.lbl30' }),
          type: 'bar',
          stack: 'Ad',
          data: LYExitData,
          color: '#7E8BE8',
        },
        {
          // name: 'LY 新会员',
          name: formatMessage({ id: 'report.health.n05.lbl29' }),
          type: 'bar',
          stack: 'Ad',
          data: LYNewData,
          color: '#D3E8F4',
        },
      ],
    };

    return option;
  }, [
    LYExitData,
    LYNewData,
    TYExitData,
    TYNewData,
    charts.axisLineColor,
    charts.yColor,
    chartsFontSize.s03,
    fontFamily,
    formatMessage,
    iconId,
    yearFirst,
    yearSecond,
  ]);

  // 点击左侧图标切换右侧图表
  const handleChangeCharts = useCallback((icons) => {
    setIconId(icons.id);
  }, []);

  return (
    <KPITrendStyled theme={theme}>
      <div className="trend-wrap">
        <Box className="trend-left">
          <div className="sales-icon-wrap">
            <SvgIcon name={'KPITrend'} size={22} fill="#1565C0" />
            <div>
              {/* 指标趋势 */}
              {formatMessage({ id: 'report.health.n05.lbl01' })}
            </div>
          </div>
          <div className="condition-wrap">
            {showCondition &&
              showCondition.map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleChangeCharts(item, index)}
                >
                  <MenuItem
                    key={item.id}
                    value={item.value}
                    name={item.name}
                    selected={item.id === iconId}
                    className={
                      item.id === iconId
                        ? 'isChanged condition-item-wrap'
                        : 'condition-item-wrap noChange'
                    }
                  >
                    <SvgIcon
                      name={item.icon}
                      size={15}
                      color={item.id === iconId ? '#fff' : '#1D8FC0'}
                    />
                    <span className="icon-divider"></span>
                    {item.value}
                    {/* <TooltipsML
                      title={item.title}
                      color={item.id === iconId ? '#fff' : ''}
                    ></TooltipsML> */}
                  </MenuItem>
                </div>
              ))}
          </div>
        </Box>
        <Box className="trend-right">
          <Loading loading={loading}>
            {loading ||
            LYExitData?.length > 0 ||
            TYNewData?.length > 0 ||
            TYExitData?.length > 0 ||
            LYNewData?.length > 0 ? (
              <>
                {/* <TooltipsML
                  // title={'趋势图展示的TY和LY对应的年份数'}
                  title={formatMessage({ id: 'report.health.n05.tip26' })}
                  isAbsolute={true}
                  left={'187px'}
                  top={'-2px'}
                ></TooltipsML> */}
                <ReactEChartsCore
                  echarts={echarts}
                  lazyUpdate={true}
                  option={chartOption}
                  notMerge={true}
                  style={CHART_STYLE}
                />
              </>
            ) : (
              <div className="nodata-wrap">
                <NoData loading={loading} />
              </div>
            )}
          </Loading>
        </Box>
      </div>
    </KPITrendStyled>
  );
};

export default KPITrend;
